export default __webpack_public_path__ + "static/media/Morph Child of the Goat.18d3faa2.jpg";